export default "__VITE_ASSET__C81TaTp3__"